import React from "react";
import { Box, MainCard, MainTitle } from "app/components/common";
import selectLanguage from "../../utils/selectLanguage";
import OptionBar from "../Signup/Onboarding/OptionBar";
import { ScrollView } from "react-native-gesture-handler";
import { useSelector } from "react-redux";
import { getLanguage } from "@microdoing/shared/services/profileSettings/selectors";
import normalize from "app/utils/normalize";

const MultipleChoices = ({ title, options, choices, onPressChoice }) => {
  const renderOption = (item, index) => {
    const language = useSelector(getLanguage);
    const option = item;
    const optionTitle = selectLanguage({ text: option, language });
    const isSelected = choices.some(
      choice => selectLanguage({ text: choice, language }) === optionTitle,
    );

    return (
      <Box
        key={index}
        marginBottom={options.length - 1 === index ? "null" : "sm"}
        minHeight={normalize(52)}
        width="100%"
        borderRadius={normalize(8)}
        alignItems="center"
        justifyContent="center"
        borderWidth={1}
        borderColor="neutral.100"
      >
        <OptionBar
          onPress={onPressChoice(option)}
          isSelected={isSelected}
          text={optionTitle}
        />
      </Box>
    );
  };

  return (
    <Box flex={1} width="100%">
      <MainTitle variant="l6-bold" textAlign="center">
        {title}
      </MainTitle>
      <Box flex={1} marginTop="xm">
        <MainCard
          padding={{
            phone: "xm",
            web: "l",
          }}
          backgroundColor="neutral.white"
          borderWidth={1}
          borderColor="neutral.100"
        >
          <ScrollView>
            {options.map((item, index) => renderOption(item, index))}
          </ScrollView>
        </MainCard>
      </Box>
    </Box>
  );
};

export default MultipleChoices;
